module.exports = __webpack_public_path__ + "img/contact.b754d10a.png";